import { graphql } from 'gatsby';
import { UnorderedList, ListItem } from '@twilio-paste/list';
import { Card } from '@twilio-paste/card';
import { Stack } from '@twilio-paste/stack';
import { Alert } from '@twilio-paste/alert';
import { Anchor } from '@twilio-paste/anchor';
import { Disclosure, DisclosureHeading, DisclosureContent } from '@twilio-paste/disclosure';
import { Link } from 'gatsby';
import * as React from 'react';
export default {
  graphql,
  UnorderedList,
  ListItem,
  Card,
  Stack,
  Alert,
  Anchor,
  Disclosure,
  DisclosureHeading,
  DisclosureContent,
  Link,
  React
};